export default "https://cdn-static.gokick.com/assets/f3c431ab621bc71377aad81f5421d83f1421a0d2/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";